import { defineMessages } from 'react-intl';

export default defineMessages({
    saving: {
        id: 'ml.policychange.MLDriverChangeAddDriverPopup.saving',
        defaultMessage: 'Saving...'
    },
    selectDriver: {
        id: 'ml.policychange.MLDriverChangeAddDriverPopup.selectDriver',
        defaultMessage: 'Please enter the missing information. This is a required field.'
    }
});